<template>
    <div>
        <add-categorie
        :is-prompt-active="addNewPrompt"
        @closePrompt="toggleDataPrompt"
        :addCallBack="addCallBack"
        />
        <update-category
        :is-prompt-active="updateNewPrompt"
        @closePrompt="toggleUpdatePrompt"
        :update-call-back="updateCallBack"
        :category="category"
        />
        <vs-table search :data="categories">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <vs-button
                            color="primary"
                            icon="refresh"
                            class="mr-1"
                            @click="getList(page)">
                        Actualiser
                    </vs-button>
                    <vs-button v-if="isAdmin()"
                            color="primary"
                            icon="add"
                            class="mr-1"
                            @click="addNewPrompt = true">
                        Ajouter
                    </vs-button>
                </div>
            </div>
            <template slot="thead">
                <vs-th>Nom</vs-th>
                <vs-th>Description</vs-th>
                <vs-th>Total</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>{{ tr.name }}</vs-td>
                    <vs-td>{{ tr.description }}</vs-td>
                    <vs-td>{{ tr.subjects_count }}</vs-td>
                    <td class="whitespace-no-wrap">
                        <div class="flex">
                            <vx-tooltip text="Modifier la catégorie" v-if="isAdmin()">
                                <feather-icon @click="updateNewPrompt = true, category = {...tr}"
                                              icon="EditIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Supprimer la catégorie" v-if="isAdmin()">
                                <feather-icon @click="showDeleteModal(tr)"
                                              icon="XIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>
                        </div>
                    </td>

                </vs-tr>
            </template>
        </vs-table>

        <vs-popup class="holamundo" title="Attention" :active.sync="alertSubject">
            <p>Vous ne pouvez pas supprimer une catégorie liées à des sujets.</p>
        </vs-popup>

        <vs-prompt color="red" title="Suppression" @cancle="activeSuppression = false"
                   @accept="supprimer()" accept-text="OUI"
                   @close="activeSuppression = false" :active.sync="activeSuppression">
            <div>
                <span style="color:red">{{ itemTodelete && itemTodelete.subjects_count > 0 ? 'Des sujets sont liés à cette catégorie' : '' }}</span><br>
                <span>Etes-vous sûr de vouloir faire cette suppression ?</span>
            </div>
        </vs-prompt>

        <br>
        <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    import {_buildQuery} from "../../../helpers/buildquery";
    import addCategorie from "./add";
    import updateCategory from "./update";

    var headers = require("./headers.js")


    export default {
        components: {
            addCategorie, updateCategory
        },
        watch: {
            page: function (value) {
                this.getList(value)
            }
        },
        data() {
            return {
                categories: [],
                addNewPrompt: false,
                updateNewPrompt: false,
                category: {},
                last_page: null,
                page: 1,
                alertSubject: false,
                itemTodelete: null,
                activeSuppression: false,
                url: '/categories/subjects'
            }
        },
        computed: {},
        methods: {
            isAdmin() {
                return this.$store.state.AppActiveUser.roles[0].name === 'admin' ? true : false;
            },
            isAgent() {
                // console.log('this.$store.state.AppActiveUser.roles[0].name: ', this.$store.state.AppActiveUser.roles[0].name)
                return this.$store.state.AppActiveUser.roles[0].name === 'agent' ? true : false;
            },
            isTeamChef() {
                return this.$store.state.AppActiveUser.roles[0].name === 'chef equipe' ? true : false;
            },
            isRegionalSupervisor(){
                return this.$store.state.AppActiveUser.roles[0].name === 'superviseur regional' ? true : false;
            },
            addCallBack(model) {
                this.categories.unshift(model)
            },
            toggleDataPrompt(val = false) {
                this.addNewPrompt = val;
            },
            toggleUpdatePrompt(val = false) {
                this.updateNewPrompt = val;
            },
            addCallBack() {
               this.getList(this.page)
            },
            updateCallBack() {
               this.getList(this.page)
            },
            getList(page) {
                this.$vs.loading()
                let params = {
                    page: page,
                    limit: 10
                }
                this.$http.get(this.url + _buildQuery(params))
                    .then((response) => {
                        this.$vs.loading.close();
                        this.categories = response.data.data
                        this.last_page = response.data.last_page
                    })
                    .catch((error) => {
                        window.getApp.error(error)
                    })
            },

            supprimer() {
                this.$vs.loading()
                this.$http.delete(this.url + `/${this.itemTodelete.slug}`)
                    .then((response) => {
                        window.getApp.success(window.getApp.suppresionMessage, response);
                        this.getList()
                    })
                    .catch((error) => {
                        window.getApp.error(error)
                    })


            },
            showDeleteModal(itemSupprimer){
                this.activeSuppression = true;
                this.itemTodelete = itemSupprimer
                /*
                if (itemSupprimer.subjects_count > 0) {
                    this.$vs.notify({
                        title: 'Erreur',
                        text: 'Des sujets sont liés à cette catégorie',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-right'
                    })
                    //this.alertSubject = true;
                } else {
                    this.activeSuppression = true;
                    this.itemTodelete = itemSupprimer
                }
                */
            },
            acceptAlert() {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Deleted image',
                    text: 'The selected image was successfully deleted'
                })
            },
        },
        created() {

        },
        mounted() {
            this.getList(this.page)
        }
    }
</script>
